const URLs = {
  login: '/login',
  signup: '/signup',
};

export default URLs;